var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEyeClose = function SvgEyeClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eye-close_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.027 14c0-2.093 1.779-3.791 3.973-3.791s3.972 1.698 3.972 3.792-1.778 3.791-3.972 3.791-3.973-1.697-3.973-3.791"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14 23.333c4.942 0 9.2-5.004 11.125-7.684a2.79 2.79 0 0 0 0-3.3C23.2 9.67 18.943 4.667 14 4.667S4.8 9.67 2.874 12.35a2.79 2.79 0 0 0 0 3.3C4.8 18.33 9.057 23.332 14 23.332m0-14.875c3.206 0 5.805 2.48 5.805 5.541S17.207 19.541 14 19.541c-3.207 0-5.806-2.481-5.806-5.542s2.6-5.541 5.806-5.541"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.108 3.042c.423-.4 1.09-.381 1.49.042l17.925 18.98a1.054 1.054 0 1 1-1.533 1.448L5.065 4.532c-.4-.423-.38-1.09.043-1.49",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M9.297 4.448c.424-.4 1.09-.38 1.49.043L28.714 23.47a1.054 1.054 0 0 1-1.533 1.448L9.255 5.938c-.4-.423-.381-1.09.042-1.49",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "eye-close_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v28H0z"
  })))));
};
export default SvgEyeClose;